import React from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import Star from '../Star';
import s from './SaleIndicator.scss';

export interface Props {
  /**
   * A number between 1-100, but in string form. A percent sign and some text will be appended to it by this component.
   */
  discount: string;

  /**
   * Alters the label's line-height.
   */
  size: 'medium' | 'small';

  background: 'themed' | 'black';

  withSparkles?: boolean;

  className?: string;
}

const SaleIndicator: React.FC<Props> = ({
  discount,
  size,
  background,
  withSparkles,
  className,
}) => {
  const { t } = useTranslation();
  return (
    <span
      className={c(
        s['root'],
        size === 'small' && s['small'],
        background === 'themed' && s['themed'],
        background === 'black' && s['black'],
        className
      )}
    >
      {t('buyCoreButton.sale', {
        sale: discount,
      })}
      {withSparkles && (
        <>
          <Star
            className={s['star-one']}
            fill={background === 'themed' ? 'themed' : 'white'}
          />
          <Star
            className={s['star-two']}
            fill={background === 'themed' ? 'themed' : 'white'}
          />
          <Star
            className={s['star-three']}
            fill={background === 'themed' ? 'themed' : 'white'}
          />
        </>
      )}
    </span>
  );
};

SaleIndicator.displayName = 'SaleIndicator';

export default SaleIndicator;
